module.exports = __webpack_public_path__ + "static/media/folder-list.18aafb01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/folder-list.svg
// module id = 443
// module chunks = 0 1